<template>
   <limitedlayout>
    <div
      ref="row_default"
      class="row mb-4"
    >
      <div class="col-lg-7 py-2">
        <h5 class="mr-2 font-weight-bold d-inline">KANBAN DA VAGA</h5>
        <h5
          class="color-primary d-inline"
          style="text-transform: uppercase"
        >
          {{ job.title }}
        </h5>
      </div>
      <div class="col-lg-5">
        <div
          v-show="!new_column"
          class="create_column"
        >
          <button
            @click="enable_create_column"
            type="button"
            class="btn full btn-primary radius-0 f13 p-2"
          >
            <span> ADICIONAR COLUNA </span>
          </button>
        </div>
        <div
          class="create_column"
          v-show="new_column"
        >
          <div class="input-group">
            <input
              type="text"
              ref="column_name"
              class="form-control"
              placeholder="Nome "
              aria-label="nome da coluna"
              aria-describedby="basic-addon2"
              v-on:keyup.enter="createColumn"
              v-model="column_name"
              autofocus
            />
            <div class="input-group-append">
              <button
                @click="createColumn"
                class="btn btn-success"
                type="button"
              >
                <font-awesome-icon
                  icon="check"
                  class="mr-2"
                />
              </button>
              <button
                @click="new_column = false"
                class="btn btn-danger"
                type="button"
              >
                <font-awesome-icon
                  icon="times"
                  class="mr-2"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="py-2">
          <inertia-link
            :href="`/recruiters/limited_jobs/${job.id}/applies`"
            type="button"
            style="margin-top: -5px"
            class="btn right pointer mr-2 color-primary"
          >
            <font-awesome-icon
              icon="list-ul"
              class="f20"
            />
          </inertia-link>
          <button
            type="button"
            v-clipboard:copy="job_url"
            v-clipboard:success="onCopy"
            style="margin-top: -5px"
            class="btn right pointer mr-2 color-primary"
          >
            <font-awesome-icon
              icon="link"
              class="f20"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div class="bg-aqua px-3">
          <span class="f30 font-weight-bold">{{ total_apply }}</span>
          <span class="f12 font-weight-bold">CANDIDATOS(AS)</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div
          class="px-3 color-white"
          style="background-color: #241a3f"
        >
          <span class="f30 font-weight-bold">{{ total_selected }}</span>
          <span class="f12 font-weight-bold">QUALIFICADOS(AS)</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div class="bg-aqua px-3">
          <span class="f30 font-weight-bold">{{ reproved }}</span>
          <span class="f12 font-weight-bold">REPROVADOS(AS)</span>
        </div>
      </div>
    </div>
    <draggable
      :list="selective_processes"
      :disabled="!can_dragg"
      v-bind="dragOptions"
      class="list-group direction_row list_block ml-4 mr-4"
      ghost-class="ghost"
      @change="changeColumn"
    >
      <transition-group
        :style="`width: ${width_kanban}px`"
        type="transition"
        ref="transition_div"
        class="transition_column"
        name="flip-list"
      >
        <div
          class="column_kanban painel-candidate mr-3"
          v-for="(selective_process, index) in selective_processes"
          :key="selective_process.id"
          :style="{ backgroundColor: background_color(selective_process) }"
        >
          <HeaderColumnKanban
            :selective_process="selective_process"
            :index="index"
            :gallery="gallery"
            :total_in_column="applies[selective_process.position].length"
            :questions="questions[selective_processes[index].position]"
            style="text-transform: uppercase"
          />
          <draggable
            class="list-group"
            ghost-class="ghost"
            @change="moveCandidate($event, selective_process)"
            v-bind="dragOptions"
            :list="applies[selective_process.position]"
            group="candidates"
          >
            <transition-group
              type="transition"
              class="direction_column"
              name="flip-list"
            >
              <div
                class="bg-white mt-2 card_candidate"
                v-for="(apply, i) in applies[selective_process.position]"
                @click="
                  show(
                    apply.id,
                    apply.candidate.id,
                    i,
                    applies[selective_process.position]
                  )
                "
                :key="apply.id"
                :style="{
                  borderRightColor: apply.tag_color,
                  borderLeftWidth: 4,
                }"
              >
                <div class="img_card_block">
                  <img
                    class="img_card mr-1"
                    :src="
                      apply.image === '' ? '/images/avatar.png' : apply.image
                    "
                  />
                </div>
                <div class="text_card">
                  <span>
                    {{ apply.candidate.name }}
                  </span>
                  <StarRating
                    active-color="#9472F8"
                    :read-only="true"
                    :rating="apply.rating_agg ? apply.rating_agg : 0"
                    v-bind:max-rating="5"
                    v-bind:star-size="15"
                    :show-rating="false"
                  ></StarRating>

                  <span class="big-small-text">{{
                    apply.candidate.email
                  }}</span>
                  <p style="text-transform: uppercase">
                    <i class="fas fa-user-tag color-primary"></i>
                    {{
                      apply.tag_name != null ? apply.tag_name : "Sem Etiqueta"
                    }}
                  </p>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </transition-group>
    </draggable>
  </limitedlayout>
</template>

<script>
import ApplyShow from "@/Recruiters/Applies/Show.vue";
import StarRating from "vue-star-rating";
import HeaderColumnKanban from "components/LimitedHeaderColumnKanban.vue";
import ComfirmFeedback from "@/Recruiters/LimitedFeedback/Confirm.vue";
import ConfirmQuestions from "@/Recruiters/SelectedQuestions/Confirm.vue";
import draggable from "vuedraggable";
export default {
  props: ["job", "job_url", "gallery", "recruiter_id", "is_limited"],
  components: { draggable, HeaderColumnKanban, StarRating },
  data: () => ({
    can_dragg: true,
    width_kanban: 990,
    new_column: false,
    column_name: "",
    selective_processes: [],
    applies: [],
    questions: [],
    total_apply: 0,
    total_selected: 0,
    reproved: 0,
  }),
  mounted() {
    this.make();
    this.width_kanban = this.$refs.row_default.clientWidth;
    eventBus.$on("remove_column", (index) => {
      this.selective_processes.splice(index, 1);
    });
    eventBus.$on("makeKanban", (field) => {
      this.make();
    });
    eventBus.$on("setDraggable", (value) => {
      this.can_dragg = value;
    });

    eventBus.$on("clouseModalEditFeedback", (field) => {
      this.$modal.hideAll();
      this.make();
    });
  },

  methods: {
    haveRightAnswer(question) {
      let excluded_types = [0, 1, 4];
      if (excluded_types.includes(question.response_type)) return false;

      let choices = question.choices;
      if (choices.correctAnswer && choices.correctAnswer != "any") return true;

      if (question.response_type == 2) {
        let rightOptions = choices.options.filter((el) => el.rightAnswer);

        return (
          rightOptions.length > 0 &&
          rightOptions.length != choices.options.length
        );
      }

      return false;
    },
    background_color(selective_process) {
      if (selective_process.status == 1) return "#d4dcdf";
      if (selective_process.status == 3) return "#dbeac1";

      return "#ededed";
    },
    show(apply_id, candidate_id, index, applies) {
      let questions_count = this.job.questions.filter((question) =>
        this.haveRightAnswer(question)
      ).length;

      let percentage = Math.floor(
        (applies[index].point * 100) / questions_count
      );

      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: applies,
          job_id: this.job.id,
          apply_id: apply_id,
          job_name: this.job.title,
          candidate_id: candidate_id,
          recruiter_id: this.recruiter_id,
          talent_bank_id: applies[index].talent_bank_id,
          hitsPercentage: percentage,
          is_limited: this.is_limited
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("setDraggable", true);
            this.make();
          },
        }
      );
    },
    make() {
      axios
        .get(`/recruiters/limited_jobs/${this.job.id}/kanban.json`)
        .then((response) => {
          this.selective_processes = response.data.selective_processes;
          this.applies = response.data.applies;
          this.questions = response.data.questions;
          this.total_apply = response.data.total_apply;
          this.total_selected = response.data.total_selected;
          this.reproved = response.data.reproved;
        });
    },
    confirmFeedback(
      feedback,
      selective_process,
      candidate,
      apply,
      questions = false,
      bigfive
    ) {
      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: [candidate],
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: selective_process.id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          clickToClose: false,
          // }
        },
        {
          closed: (event) => {
            if (selective_process.status === 1) return;
            if (questions || bigfive)
              this.openConfirmQuestions(selective_process.uid, apply, bigfive);
          },
        }
      );
    },
    openConfirmQuestions(selective_process_uid, apply, bigfive) {
      this.can_dragg = false;

      this.$modal.show(
        ConfirmQuestions,
        {
          selective_process_uid,
          applies: [{ ...apply.candidate, ...apply }],
          bigfive,
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("setDraggable", true);
          },
        }
      );
    },
    moveCandidate(element, column) {
      if (element["added"] || element["moved"]) {
        let element_now = element["moved"];
        if (element["added"]) element_now = element["added"];

        axios
          .put(`/recruiters/jobs/${this.job.id}/kanban/move_candidate`, {
            kanban: {
              apply_id: element_now.element.id,
              position: element_now["newIndex"],
              selective_process_id: column.id,
            },
          })
          .then((response) => {
            this.make();
            if (response.data.feedback) {
              this.confirmFeedback(
                response.data.feedback,
                column,
                response.data.candidate,
                element_now.element,
                response.data.questions,
                response.data.bigfive
              );

              return;
            }
            if (response.data.questions || response.data.bigfive) {
              if (column.status === 1) return;
              this.openConfirmQuestions(
                column.uid,
                element_now.element,
                response.data.bigfive
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSP");
    },
    changeColumn: function (e) {
      axios.put(`/recruiters/jobs/${this.job.id}/kanban/columns`, {
        kanban: { columns: this.selective_processes },
      });
    },
    enable_create_column() {
      this.new_column = true;
      this.$refs.column_name.focus();
    },
    createColumn() {
      axios
        .post(`/recruiters/jobs/${this.job.id}/kanban/columns`, {
          kanban: { column_name: this.column_name },
        })
        .then((response) => {
          this.make();
          this.new_column = false;
          this.column_name = "";
        });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
